import React from "react";
import { Box, Typography, Button } from "@mui/material";

const emptyStateSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  color: "text.secondary",
};

const TradeBlotterEmptyState = ({
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <Box sx={emptyStateSx}>
    <Typography variant="body1" sx={{ mb: description ? 1 : 0 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ mb: onAction ? 2 : 0 }}>
        {description}
      </Typography>
    )}
    {onAction && (
      <Button variant="outlined" size="small" onClick={onAction} sx={{ textTransform: "none" }}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default TradeBlotterEmptyState;
